import { render, staticRenderFns } from "./tou.vue?vue&type=template&id=52200ad6&scoped=true&"
import script from "./tou.vue?vue&type=script&lang=js&"
export * from "./tou.vue?vue&type=script&lang=js&"
import style0 from "./tou.vue?vue&type=style&index=0&id=52200ad6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52200ad6",
  null
  
)

export default component.exports